module.exports = __webpack_public_path__ + "static/media/blog-30.1916a99a.webp";